import { cloneElement, createContext, useContext, ReactElement } from "react";
import { TProfileContext } from "../types/context";
import { useAuth } from "./AuthContext";

const ProfileContext = createContext<TProfileContext>({});

const ProfileProvider = ({ children }: { children: ReactElement }) => {
  const { user } = useAuth();

  const profile = user || undefined;

  const renderBody = (ele: ReactElement) => cloneElement(ele);

  return (
    <ProfileContext.Provider
      value={{
        profile,
      }}
    >
      {renderBody(children)}
    </ProfileContext.Provider>
  );
};

const useProfile = () => useContext(ProfileContext);

export { ProfileProvider, useProfile };
